import {
  ArchiveResourcePayload,
  CreateResourcePayload,
  Resource,
  UpdateResourcePayload,
} from './types'
import { resources, generateNewResource, generateUpdatedResource } from './mockData'

export const getResources = async (): Promise<Resource[]> => {
  return Promise.resolve(resources).catch((error) => {
    return Promise.reject(error)
  })
}

export const createResource = async ({ name }: CreateResourcePayload): Promise<Resource> => {
  return Promise.resolve(generateNewResource(name)).catch((error) => {
    return Promise.reject(error)
  })
}

export const updateResource = async ({
  resourceId,
  name,
}: UpdateResourcePayload): Promise<Resource> => {
  return Promise.resolve(generateUpdatedResource(resourceId, name)).catch((error) => {
    return Promise.reject(error)
  })
}

export const archiveResource = async ({ resourceId }: ArchiveResourcePayload): Promise<void> => {
  return Promise.resolve().catch((error) => {
    return Promise.reject(error)
  })
}
